import React, {useEffect, useState, useContext, useRef} from 'react';
import { Container, Row, Col, Tooltip, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import classes from './MiPerfil.module.css';
import {getProfile, updateProfile, updatePassword} from '../../../helpers/Profile.helper';
import {Formik} from "formik";
import { Paises } from '../../../helpers/Data.helper';
import GlobalContext from '../../../context/GlobalContext';
import { getDate, sortData } from '../../../helpers/functions.helper';
import { validateEmptyFields } from '../../../helpers/Register.helper';

const MiPerfil = () => {

    const [profile, setProfile] = useState({});
    const [modalToggle, setModalToggle] = useState(false);
    const [passModalToggle, setPassModalToggle] = useState(false);
    const [campus, setCampus] = useState([]);
    const [origins, setOrigins] = useState([]);
    const [levels, setLevels] = useState([]);

    const [isHidden, setIsHidden] = useState(true);
    const [isConfirmHidden, setIsConfirmHidden] = useState(true);
    const [isPassValid, setIsPassValid] = useState(false);
    const [passShow, setPassShow] = useState(false);
    const [ConfirmPassShow, setConfirmPassShow] = useState(false);
    const [modalHeader, setModalHeader] = useState('Cambiar contraseña');
    const [modalBody, setModalBody] = useState('');
    const [modalRedirect, setModalRedirect] = useState(false);

    const pass = useRef();
    const confirmPass = useRef();
    const icon = useRef();
    const confirmIcon = useRef();

    const {mentorProfile, setMentorProfile, setLoading} = useContext(GlobalContext);

    useEffect(()=>{
        const antiguedad = document.getElementById('iAntiguedad');
        const nomina_elem = document.getElementById('iNomina');
        const matricula_elem = document.getElementById('iMatricula');
        
        antiguedad.addEventListener('keydown', handleKeyDown);
        nomina_elem.addEventListener('keydown', handleKeyDown);
        matricula_elem.addEventListener('keydown', handleKeyDown);

        return () => {
            antiguedad.removeEventListener('keydown', handleKeyDown);
            nomina_elem.removeEventListener('keydown', handleKeyDown);
            matricula_elem.removeEventListener('keydown', handleKeyDown);
        }
    }, [])

    useEffect(() => {
        if(mentorProfile.profile){
            setProfile(mentorProfile.profile);
            setCampus(sortData(mentorProfile.campus));
            setOrigins(mentorProfile.origins);
            setLevels(mentorProfile.levels);
        }else{
            setLoading(true);
            getProfile().then(d => {
                setProfile(d.profile);
                setCampus(d.campus);
                setOrigins(d.origins);
                setLevels(d.levels);
                setMentorProfile(d);

                console.log(d);
                setLoading(false);
            }).catch(ex=>{
                console.error(ex);
                setLoading(false);
            });
        }
    }, [mentorProfile]);

    const showHidePassword = (pass, icon, isHidden, setIsHidden) => {
        if(!isHidden){
            pass.current.setAttribute('type', 'password');
            icon.current.classList.remove('fa-eye-slash');
            icon.current.classList.add('fa-eye');
            setIsHidden(true);
        }else{
            pass.current.setAttribute('type', 'text');
            icon.current.classList.remove('fa-eye');
            icon.current.classList.add('fa-eye-slash');
            setIsHidden(false);
        }
    }

    const handleOnFocus = elem => {
        const text = elem.current.closest('.input-container').children[0];
        text.classList.add('active');
        setPassShow(false);
        setConfirmPassShow(false);

        if(elem.current.id == 'pass' || elem.current.id == 'confirm-pass'){
            elem.current.select();
            elem.current.removeAttribute('style');
        }
    }

    const handleOnBlur = elem => {
        const value = elem.current.value;
        if(!value.length > 0){
            const text = elem.current.closest('.input-container').children[0];
            text.classList.remove('active');
        };

        if(elem.current.id == 'pass' || elem.current.id == 'confirm-pass'){
            validatePassword(elem);
        }
    }

    const validatePassword = elem => {
        const value = elem.current.value;

        if(value.length == 0){
            elem.current.classList.remove('active');
            setPassShow(false);
            setConfirmPassShow(false);
            return;
        }

        if(elem.current.id == 'pass'){
            if(!checkPass(value)){
                elem.current.style.border = '1px solid red';
                setPassShow(true);
                setIsPassValid(false);
            }else{
                elem.current.style.border = '1px solid green';
            }
        }else{
            const passValue = pass.current.value;
            if(value != passValue || !checkPass(value)){
                elem.current.style.border = '1px solid red';
                setConfirmPassShow(true);
                setIsPassValid(false);
            }else{
                elem.current.style.border = '1px solid green';
                setIsPassValid(true);
            }
        }
    }

    const checkPass = pass => {
        const str = pass;
        const formatSpetial = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        const formatUppercase = /[ABCDEFGHIJKLMNÑOPQRSTUVWXYZ]/;
        const formatLowercase = /[abcdefghijklmnñopqrstuvwxyz]/;
        const formatNumber = /[1234567890]/;
        if (formatSpetial.test(str) && formatUppercase.test(str) && formatLowercase.test(str) && formatNumber.test(str) && str.length >= 6)
            return true;
        else
            return false;
    }

    const handleClick = () => {
        setModalHeader('Cambiar contraseña');
        setModalBody('')

        setLoading(true);

        if(!isPassValid){
            console.log("Las contraseñas no coinciden");
            return;
        }
        
        const passwordValue = pass.current.value;
        const data = {
            idMentorVoluntario: profile.idMentorVoluntario,
            sPassword: passwordValue
        }

        updatePassword(data).then(async resp=>{
            setLoading(false);

            if(resp.status != 200 && resp.status != 202){
                const error = await resp.json();
                const message = (error.error) ? error.error : error.message;
                if(message){
                    showModal(
                        "Ha ocurrido un error.",
                        message,
                        false
                    );
                }else{
                    showModal(
                        "Ha ocurrido un error.",
                        "Ha ocurrido un error inesperado, intente de nuevo",
                        false
                    );
                }
                return;
            }
            setPassModalToggle(false);
            showModal(
                'Contraseña actualizada.',
                'Su contraseña ha sido actualizada exitosamente.'
            );
        })
    }

    const handleKeyDown = e =>{
        const nonValidatedKeys = [8, 9, 13, 16, 17];
        
        if(nonValidatedKeys.includes(e.which)){return}
        let value = e.currentTarget.value;
        if(e.currentTarget.id == 'iAntiguedad'){
            if(value.length >= 2){
                e.preventDefault()
            }
        }else{
            if(value.length >= 7){
                e.preventDefault();
            }
        }
    }

    const showModal = (header, body) => {
        setModalHeader(header);
        setModalBody(body);
        setModalToggle(true);
    }

    return(
        <Container>
            <Row>
                <Col className="title-container">
                    <div>
                        <h1>Mi Perfil</h1>
                        <span>Aquí puedes editar los datos registrados</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className={classes.dataMentorContainer}>
                        <span>ID de mentor: {profile.idMentorVoluntario}</span>
                        <span>Fecha de registro: {getDate(profile.dFechaRegistro)}</span>
                        <span>Correo electrónico: {profile.sCorreo}</span>
                        {
                            (profile.iNomina != "0")&&
                            <span>Nómina (Instituciones del Sistema Tec): {profile.iNomina}</span>
                        }
                        {
                            (profile.iMatricula != "0")&&
                            <span>Matrícula: {profile.iMatricula}</span>
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className={classes.col}>
                    <div className={classes.inputsContainer}>
                        <Formik
                            enableReinitialize={true}
                            initialValues={{...profile}}
                            validate={values => {
                                const errors = {};
                            }}
                            onSubmit={(values, { setSubmitting }) => {
                                const validation = validateEmptyFields(values);
                                if(validation != false){
                                    showModal(
                                        "Uno o más campos están vacíos.",
                                        validation,
                                        false
                                    );
                                    return;
                                }else{
                                    setLoading(true);
                                    updateProfile(values).then(() => {
                                        getProfile().then(data => {
                                            Formik.isSubmitting = false;
                                            window.scrollTo(0,0);
                                            setProfile(data.profile);
                                            setCampus(data.campus);
                                            setOrigins(data.origins);
                                            setLevels(data.levels);
                                            setMentorProfile(data);
                                            setLoading(false);
                                        }).catch(error => {
                                            setLoading(false);
                                            Formik.isSubmitting = false;
                                            window.scrollTo(0,0);
                                            window.location.reload();
                                        })
                                    });
                                }
                            }}
                        >
                            {({
                                  values,
                                  errors,
                                  handleChange,
                                  handleSubmit,
                                  isSubmitting,
                              }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className={classes.inputContainer} style={{maxWidth: "70%"}}>
                                        <label className={classes.text} htmlFor="sNombre">Nombre*</label>
                                        <input type="text" id="sNombre" className={classes.input}  onChange={handleChange} value={values.sNombre}/>
                                    </div>

                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="sSexo">Género*</label>
                                        <select id="sSexo" className={classes.input} onChange={handleChange} value={values.sSexo}>
                                            <option value="Masculino">Masculino</option>
                                            <option value="Femenino">Femenino</option>
                                            <option value="0">Prefiero no decirlo</option>
                                        </select>
                                    </div>

                                    {/* <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="sPaisResidencia">País de residencia</label>
                                        <input type="text" id="sPaisResidencia" className={classes.input} onChange={handleChange} value={values.sPaisResidencia} />
                                    </div> */}

                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="sCiudadResidencia">Ciudad de residencia*</label>
                                        <input type="text" id="sCiudadResidencia" className={classes.input} onChange={handleChange} value={values.sCiudadResidencia} />
                                    </div>

                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text + ' active'} htmlFor="sPaisResidencia">País de residencia*</label>
                                        <select id="sPaisResidencia" className={classes.input} onChange={handleChange} value={values.sPaisResidencia}>
                                            {
                                                Paises.map((item, index)=>(
                                                    (item.nombre)&&
                                                    <option value={item.nombre} key={item.id}>{item.nombre}</option>
                                                ))
                                            }
                                        </select>
                                    </div>

                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="idCampus">Campus presencial más cercano*</label>
                                        <select id="idCampus" className={classes.input} onChange={handleChange} value={values.idCampus}>
                                            {
                                                campus.map((item, index)=>(
                                                    <option value={item.idCampus} key={item.idCampus}>{item.sCampus}</option>
                                                ))
                                            }
                                        </select>
                                    </div>

                                    <span className={classes.subtitle}>Perteneces a la comunidad Tecmilenio o Tec</span>
                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text} htmlFor="idOrigen">Segmento al que perteneces*</label>
                                        <select id={"idOrigen"} className={classes.input} onChange={handleChange} value={values.idOrigen}>
                                            {
                                                origins.map((item,index)=>(
                                                    <option value={item.idOrigen} key={item.idOrigen}>{item.sOrigen}</option>
                                                ))
                                            }
                                        </select>
                                    </div>

                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="iNomina">Nómina*</label>
                                        <input type="number" id="iNomina" className={classes.input} onChange={handleChange} value={values.iNomina==0?"":values.iNomina}/>
                                    </div>

                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="iMatricula">Matrícula* (estudiante)</label>
                                        <input type="number" id="iMatricula" className={classes.input} onChange={handleChange} value={values.iMatricula==0?"":values.iMatricula}/>
                                    </div>

                                    <span className={classes.subtitle}>Perteneces a la comunidad Tecmilenio o Tec</span>
                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="sEmpresa">Nombre de la empresa*</label>
                                        <input type="text" id="sEmpresa" className={classes.input} onChange={handleChange} value={values.sEmpresa}/>
                                    </div>

                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="iAntiguedad">Años en la empresa*</label>
                                        <input type="number" id="iAntiguedad" className={classes.input} onChange={handleChange} value={values.iAntiguedad==0?"":values.iAntiguedad}/>
                                    </div>

                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="sPuesto">Puesto*</label>
                                        <input type="text" id="sPuesto" className={classes.input} onChange={handleChange} value={values.sPuesto}/>
                                    </div>

                                    <div className={classes.inputContainer}>
                                        <label className={classes.text} htmlFor="sPrincipalesActividades">Principales actividades que realizas*</label>
                                        <input type="text" id="sPrincipalesActividades" className={classes.input} onChange={handleChange} value={values.sPrincipalesActividades}/>
                                    </div>

                                    <span className={classes.subtitle}>Selecciona el segmento de estudiantes al que preferirías dar mentoría</span>
                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text} htmlFor="idNivel">Segmento de estudiantes preferido*</label>
                                        <select id={"idNivel"} className={classes.input} onChange={handleChange} value={values.idNivel}>
                                            {
                                                levels.map((item,index)=>(
                                                    <option value={item.idNivel} key={item.idNivel}>{item.sNivel}</option>
                                                ))
                                            }
                                        </select>
                                    </div>

                                    <div className={"input-container " + classes.inputContainer} style={{maxWidth: "70%"}}>
                                        <label className={classes.text} htmlFor="sMotivos">Motivos para ser mentor voluntario*</label>
                                        <textarea id="sMotivos" className={classes.input} onChange={handleChange} value={values.sMotivos}/>
                                    </div>

                                    <input type="submit" className={classes.button} value="Guardar cambios"/>
                                    <input type="button" className={classes.updatePassBtn} value="Cambiar contraseña" onClick={()=>setPassModalToggle(true)}/>

                                </form>
                            )}
                        </Formik>
                    </div>

                    {/* CHANGE PASS MODAL */}
                    <div>
                        <Modal size="lg" isOpen={passModalToggle} >
                            <ModalHeader toggle={()=>{setPassModalToggle(!passModalToggle)}}>{modalHeader}</ModalHeader>
                            <ModalBody>
                                <div className={classes.flexContainer}>
                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text} htmlFor="pass">Nueva contraseña</label>
                                        <span>
                                            <input type="password" id="pass" is-hidden="true" className={classes.input}
                                            onFocus={()=>{handleOnFocus(pass)}} onBlur={()=>{handleOnBlur(pass)}} ref={pass}/>
                                            <span className={classes.icon} onClick={()=>{showHidePassword(pass, icon, isHidden, setIsHidden)}}><i className="fas fa-eye" ref={icon}></i></span>
                                        </span>
                                        <Tooltip placement="top" fade={false} isOpen={passShow} target="pass">
                                            La contraseña debe de contener mínimo 6 caracteres, una minúscula, una mayúscula, un número y un caracter especial.
                                        </Tooltip>
                                    </div>
                                    <div className={"input-container " + classes.inputContainer}>
                                        <label className={classes.text} htmlFor="confirm-pass">Confirmar contraseña</label>
                                        <span>
                                            <input type="password" id="confirm-pass" is-hidden="true" className={classes.input}
                                            onFocus={()=>{handleOnFocus(confirmPass)}} onBlur={()=>{handleOnBlur(confirmPass)}} ref={confirmPass}/>
                                            <span className={classes.icon} onClick={()=>{showHidePassword(confirmPass,confirmIcon, isConfirmHidden, setIsConfirmHidden)}}><i className="fas fa-eye" ref={confirmIcon}></i></span>
                                        </span>
                                        <Tooltip placement="top" fade={false} isOpen={ConfirmPassShow} target="confirm-pass">
                                            Las contraseñas deben coincidir.
                                        </Tooltip>
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={handleClick} >
                                    Aceptar
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>

                    {/* MODAL */}
                    <div>
                        <Modal size="lg" isOpen={modalToggle} >
                            <ModalHeader toggle={()=>{setModalToggle(!modalToggle)}}>{modalHeader}</ModalHeader>
                            <ModalBody>{modalBody}</ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={()=>{setModalToggle(!modalToggle)}} >
                                    Aceptar
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>

                </Col>
            </Row>
        </Container>
    );
}
export default MiPerfil;
